import React from 'react';

import {MainLayout} from 'widgets/layout';
import {Locations} from 'features/admin';

const AdminCitiesPage: React.FC = () => {

    return (
        <MainLayout>
            <Locations />
        </MainLayout>
    );
};

export default AdminCitiesPage;